import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { KNgDataTableModule } from '@kortobaa-front/k-ng-datatable';
import { Subscription } from 'rxjs';
import { PlatformService } from '../../../core/services/platform.service';
import { Notification } from '../../../shared/interfaces/notification';
import { DatePipePipe } from '../../../shared/pipes/date-pipe.pipe';
import { NotificationService } from './notification.service';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatDividerModule,
    MatSlideToggleModule,
    FormsModule,
    KNgDataTableModule,
    DatePipePipe,
  ],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent {
  @ViewChild('openNotify') openNotify!: ElementRef;
  // toggleOn: boolean = false;
  toggleOff: boolean = true;
  notifySub$!: Subscription;
  notifyAllSub$!: Subscription;
  notifyAllCountSub$!: Subscription;
  notifyCountSub$!: Subscription;
  notifySeenSub$!: Subscription;
  notifyOpenSub$!: Subscription;
  notifyNewSub$!: Subscription;
  notifyLoadSub$!: Subscription;
  notifyRouteSub$!: Subscription;
  notifications: Notification[] = [];
  notificationsCount: any = [];
  infiniteScrollCounter: number = 0;
  hasMoreNotifications: boolean = true;
  notSeenNotifySub$!: Subscription;
  @Input() hasUnseenNotification!: number;
  loading: boolean = false;
  notificationAllCount!: number;
  notifyRedirect: {
    value: string | string[];
    routePattern: string;
  }[] = [
      {
        value: 'donation_timeline_created',
        routePattern: 'donation-details/{extraType}/{id}',
      },
      {
        value: 'management_create_donation',
        routePattern: 'donation-details/{extraType}/{id}',
      },
      {
        value: ['management_user_profile_created', 'management_user_profile_updated'],
        routePattern: 'users-accounts/{id}/user-details',
      },
    ];

  secondaryColor = 'var(--secondary-color)';
  markingAllAsRead: boolean = false;
  allNotificationsRead: boolean = false;

  constructor(
    public notification: NotificationService,
    private _router: Router,
    private renderer: Renderer2,
    public _platForm: PlatformService
  ) {
    this.notifySub$ = this.notification.getCloseDialog().subscribe((res) => {
      if (this.openNotify?.nativeElement) {
        if (res == 'close') {
          this.openNotify.nativeElement.style.display = 'none';
          this.openNotify.nativeElement.children[1].style.width = '0';
          document.body.classList.remove('hidden');
        } else {
          document.body.classList.add('hidden');
          this.openNotify.nativeElement.style.display = 'block';
        }
      }
    });
    this.notifySeenSub$ = this.notification
      .getSeenNotification()
      .subscribe((data) => {
        if (!data)
          this.notifications.forEach((notification: any) => {
            notification.seen = true;
          });
      });
    this.renderer.listen('window', 'click', (e: any) => {
      if (
        !this.openNotify.nativeElement.children[1].contains(e.target) &&
        e.target?.id != 'notify'
      ) {
        this.notification.emitCloseDialog('close');
        document.body.classList.remove('hidden');
        // this.toggleOn = false;
        this.toggleOff = true;
      }
    });
    this.notifyOpenSub$ = this.notification
      .getOpenDialog()
      .subscribe((data) => {
        this.loading = true;
        this.notifyAllCountSub$ = this.notification
          .getNotificationsCounter()
          .subscribe((data: any) => {
            this.notificationAllCount = data ? data.count : 0;
          });
        this.notifyAllSub$ = this.notification
          .getNotificationsScroll(5, 0)
          .subscribe((data) => {
            this.loading = false;
            this.notifications = data as Notification[];
            this.infiniteScrollCounter = 5;
            this.hasMoreNotifications = true;
            this.checkAllNotificationsRead();
          });
        this.notifyCountSub$ = this.notification
          .getNotificationsCount()
          .subscribe((data) => {
            console.log('[NotificationComponent] Count data:', data);
            this.notificationsCount = data;
          });
      });
    this.notifyNewSub$ = this.notification
      .getNewNotification()
      .subscribe((data) => {
        this.notification
          .getNotificationsScroll(5, this.infiniteScrollCounter)
          .subscribe((data) => {
            this.notifications = data as Notification[];
            this.infiniteScrollCounter = 5;
            this.hasMoreNotifications = true;
            this.checkAllNotificationsRead();
          });
        this.notification.getNotificationsCount().subscribe((data) => {
          this.notificationsCount = data;
          this.notification.emitSeenNotification();
        });
      });
  }

  ngOnInit(): void { }

  // redirect to page
  goTo(
    app: string,
    id: number,
    notificationId: number,
    extraType: string | null
  ) {
    this.notifyRouteSub$ = this.notification
      .updateNotification(notificationId)
      .subscribe((data: any) => {
        if (app != 'message') {
          this._router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => {
              const notifyConfig = this.notifyRedirect.find((notify) => {
                return Array.isArray(notify.value)
                  ? notify.value.includes(app)
                  : notify.value === app;
              });

              if (notifyConfig) {
                let finalRoute = notifyConfig.routePattern
                  .replace('{id}', String(id))
                  .replace('{extraType}', extraType === 'companyDonor' ? 'corps' : 'individuals');

                this._router.navigateByUrl(finalRoute);
              }
            });
        }
        this.notification.emitCloseDialog('close');
        this.toggleOff = true;
        this.notification.emitSeenNotification();
      });
  }

  ngAfterContentChecked() {
    // if (
    //   (this.notifications.length < this.notificationAllCount && !this.toggleOn) ||
    //   (this.notifications.length < this.notificationsCount.count && this.toggleOn)
    // ) {
    if (
      (this.notifications.length < this.notificationAllCount &&
        this.toggleOff) ||
      (this.notifications.length < this.notificationsCount.count &&
        !this.toggleOff)
    ) {
      this.hasMoreNotifications = true;
    } else {
      this.hasMoreNotifications = false;
    }
  }

  // load more notification
  loadMore() {
    // if (this.toggleOn === true) {
    if (this.toggleOff === false) {
      // this.infiniteScrollCounter = 5;
      this.getNotSeenNotification();
    } else {
      this.notifyLoadSub$ = this.notification
        .getNotificationsScroll(5, this.infiniteScrollCounter)
        .subscribe((data: any) => {
          if (data.length > 0) {
            this.notifications = this.getUniqueObjects([
              ...this.notifications,
              ...data,
            ]);
            this.infiniteScrollCounter += 5;
            this.checkAllNotificationsRead();
          } else {
            this.hasMoreNotifications = false;
          }
        });
    }
  }

  // close notification
  close() {
    this.notification.emitCloseDialog('close');
    // this.toggleOn = false;
    this.toggleOff = true;
    document.body.classList.remove('hidden');
    this.notification.emitSeenNotification();
  }

  // toggle icon
  toggle(value: boolean) {
    // this.toggleOn = value;
    // this.toggleOff = value;
    this.hasMoreNotifications = true;
    this.infiniteScrollCounter = 0;
    this.notification
      .getNotificationsScroll(5, this.infiniteScrollCounter)
      .subscribe((data: any) => {
        this.notifications = this.getUniqueObjects(
          value
            ? data.filter((notify: any) => {
              return notify.seen == false;
            })
            : [...data]
        );
        this.checkAllNotificationsRead();
        if (value === true) {
          this.infiniteScrollCounter = 0;
          this.getNotSeenNotification();
        }
      });
  }

  // get not seen notification
  getNotSeenNotification() {
    this.notSeenNotifySub$ = this.notification
      .getNotificationSeen(5, this.infiniteScrollCounter)
      .subscribe((data: any) => {
        if (data.length > 0) {
          this.notifications = this.getUniqueObjects([
            ...this.notifications,
            ...data,
          ]);
          this.infiniteScrollCounter += 5;
          this.checkAllNotificationsRead();
        }
        if (this.notificationsCount.count == this.notifications.length) {
          this.hasMoreNotifications = false;
        }
      });
  }

  // mark all notifications as read
  markAllAsRead() {
    this.markingAllAsRead = true;
    this.notification.updateNotificationToSeen().subscribe({
      next: () => {
        this.notifications.forEach((notification: any) => {
          notification.seen = true;
        });
        this.allNotificationsRead = true;
        this.notification.emitSeenNotification();
        this.markingAllAsRead = false;
      },
      error: () => {
        this.markingAllAsRead = false;
      }
    });
  }

  // check if all notifications are read
  checkAllNotificationsRead() {
    this.allNotificationsRead = this.notifications.length > 0 &&
      this.notifications.every((notification: any) => notification.seen === true);
  }

  getUniqueObjects(array: any[]) {
    const seen = new Set();
    return array.filter((item) => {
      const key = item['id'];
      if (!seen.has(key)) {
        seen.add(key);
        return true;
      }
      return false;
    });
  }
  ngOnDestroy(): void {
    if (this.notifySub$) this.notifySub$.unsubscribe();
    if (this.notifyAllSub$) this.notifyAllSub$.unsubscribe();
    if (this.notifyCountSub$) this.notifyCountSub$.unsubscribe();
    if (this.notifySeenSub$) this.notifySeenSub$.unsubscribe();
    if (this.notifyOpenSub$) this.notifyOpenSub$.unsubscribe();
    if (this.notifyNewSub$) this.notifyNewSub$.unsubscribe();
    if (this.notSeenNotifySub$) this.notSeenNotifySub$.unsubscribe();
    if (this.notifyLoadSub$) this.notifyLoadSub$.unsubscribe();
    if (this.notifyRouteSub$) this.notifyRouteSub$.unsubscribe();
    if (this.notifyAllCountSub$) this.notifyAllCountSub$.unsubscribe();
  }
}
